import { Platform } from 'react-native';
import Config from "react-native-config";

const PLATFORM = Platform.OS === 'web' ? process.env.PLATFORM : Platform.OS // used only to diffrentiate between web and windows

const ARYA_ORG_ID = "2";

const RICE_GRAIN_ID = "18";
const MANUAL_GRAIN_ANALYSIS = "MANUAL_GRAIN_ANALYSIS";
const API_BASE_URL_V2 = () => Platform.OS === 'web' ? process.env.API_BASE_URL_V2: Config.API_BASE_URL_V2;

const S3_BUCKET_URL = () => Platform.OS === 'web' ? process.env.S3_BUCKET_URL: Config.S3_BUCKET_URL;

const S3_BUCKET_NAME = () => Platform.OS === 'web' ? process.env.S3_BUCKET_NAME: Config.S3_BUCKET_NAME;

const USER_POOL_ID = () => Platform.OS === 'web' ? process.env.USER_POOL_ID: Config.USER_POOL_ID;

const USER_POOL_WEB_CLIENT_ID = () => Platform.OS === 'web' ? process.env.USER_POOL_WEB_CLIENT_ID: Config.USER_POOL_WEB_CLIENT_ID;

const IS_TEST_ENV = () => Platform.OS === 'web' ? process.env.IS_TEST === 'true': Config.IS_TEST === 'true';

const RELEASE_STAGE = () => Platform.OS === 'web' ? process.env.RELEASE_STAGE : Config.RELEASE_STAGE;

const USER_POOL_REGION = 'us-west-2'

const ADMIN_EMAIL = "inweonapp@gmail.com"

const DOUBLE_SIDE_SCAN_TIMEOUT = 3 * 60 * 1000;
const SCAN_TIMEOUT = 2 * 60 * 1000;
const UPLOAD_TIMEOUT = 1 * 60 * 1000;
const MANUAL_UPLOAD_TIMEOUT = 1 * 10 * 1000;
const DEFAULT_SCAN_DPI = 600;

const APP_THEME = {
    primaryColor: '#000',
}

const FEATURE_FLAGS = {
    ENABLE_GRAIN_AVERAGING: true
}

const PRIVATE_ALGO_PRODUCT_IDS = new Set(['algo_l10', 'algo_w10']);
const EXPLICIT_LOGOUT_STORAGE_KEY = 'explicit_logout_requested';
const LAST_GRAIN_PROFILE_STORAGE_KEY = 'grainiq_last_grain_profile';

export {
    API_BASE_URL_V2,
    S3_BUCKET_URL,
    USER_POOL_ID,
    S3_BUCKET_NAME,
    USER_POOL_WEB_CLIENT_ID,
    IS_TEST_ENV,
    RELEASE_STAGE,
    ADMIN_EMAIL,
    MANUAL_GRAIN_ANALYSIS,
    PLATFORM,
    RICE_GRAIN_ID,
    ARYA_ORG_ID,
    USER_POOL_REGION,
    APP_THEME,
    SCAN_TIMEOUT,
    UPLOAD_TIMEOUT,
    DOUBLE_SIDE_SCAN_TIMEOUT,
    MANUAL_UPLOAD_TIMEOUT,
    DEFAULT_SCAN_DPI,
    FEATURE_FLAGS,
    PRIVATE_ALGO_PRODUCT_IDS,
    EXPLICIT_LOGOUT_STORAGE_KEY,
    LAST_GRAIN_PROFILE_STORAGE_KEY
}
